<template>
  <div id="product-analytics-modal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-body product-analytics">
          <div class="product" v-if="Object.keys(product).length">
            <div class="image">
              <img :src="product.image">
            </div>
            <div class="info">
              <div class="name">{{ product.productName }}</div>
              <div class="asin">{{ product.asin }}</div>
            </div>
          </div>
          <div class="form-search row">
            <div class="col-xs-3 pd-l-0">
              <div class="start-day">
                <label>日付From </label>
                <date-picker
                  v-model="startDay"
                  :lang="lang"
                  placeholder="日付を選択"
                  ref="datepickerStart"
                  value-type="format"
                  format="YYYY/MM/DD"
                  :not-after="startNotAfter"
                ></date-picker>
              </div>
            </div>
            <div class="col-xs-3">
              <div class="end-day">
                <label>日付To </label>
                <date-picker
                  v-model="endDay"
                  placeholder="日付を選択"
                  ref="datepickerEnd"
                  value-type="format"
                  format="YYYY/MM/DD"
                  :lang="lang"
                  :not-before="endNotBefore"
                  :not-after="endNotAfter"
                ></date-picker>
              </div>
            </div>
            <div class="col-xs-3">
              <button type="button" class="btn btn-primary w-70" @click="handleSearch()" :disabled="disableButtonApply">適用</button>
            </div>
            <div class="col-xs-3 box-btn-close">
              <button type="button" class="btn btn-default w-100" data-dismiss="modal" @click="handleClose()">閉じる</button>
            </div>
          </div>
          <div class="product-chart">
            <bar-chart v-if="chartReady" :chartData="chartData" :options="options" :heightNumber="180" :arrIndexHidden="arrAccessDataIndexHidden"></bar-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/BarChart'
import Util from '@/common/utility'
import DatePicker from 'vue2-datepicker'
import AnalyticsService from '@/services/analyticsservice'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  props: {
    product: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    BarChart,
    DatePicker
  },
  data () {
    return {
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      chartData: {
        labels: [],
        datasets: []
      },
      options: {
        responsive: true,
        legend: {
          display: true,
          position: 'right',
          labels: {
            usePointStyle: true,
            generateLabels: (chart) => {
              let datasets = chart.data.datasets
              if (datasets.length) {
                return datasets.map((dataset, index) => {
                  let meta = chart.getDatasetMeta(index)
                  if (dataset.type === 'line') {
                    if (this.arrAccessMallCodeHidden.includes(dataset.mallCode) && !this.arrAccessDataIndexHidden.includes(index)) {
                      this.arrAccessDataIndexHidden.push(index)
                    }
                    return {
                      text: dataset.label,
                      lineWidth: 4,
                      lineCap: 'square',
                      strokeStyle: dataset.backgroundColor,
                      pointStyle: 'line',
                      hidden: meta.hidden,
                      datasetIndex: index
                    }
                  } else {
                    return {
                      text: dataset.label,
                      strokeStyle: dataset.borderColor,
                      fillStyle: dataset.backgroundColor,
                      pointStyle: 'rect',
                      hidden: meta.hidden,
                      datasetIndex: index
                    }
                  }
                })
              } else {
                return []
              }
            }
          }
        },
        tooltips: {
          // mode: 'label'
        },
        plugins: {
          datalabels: {
            color: '#333333',
            formatter: function (value) {
              return ''
            }
          }
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: false,
                drawOnChartArea: false,
                drawTicks: true
              }
            }
          ],
          yAxes: [
            {
              // Access
              id: 'yaxis1',
              position: 'left',
              scaleLabel: {
                display: true,
                labelString: 'アクセス数'
              },
              ticks: {
                beginAtZero: true,
                stepSize: 500,
                callback: (value) => {
                  return this.formatAmount(value)
                }
              },
              gridLines: {
                drawBorder: false,
                drawOnChartArea: true
              }
            },
            {
              // Sales
              id: 'yaxis2',
              position: 'right',
              scaleLabel: {
                display: true,
                labelString: '売上件数'
              },
              ticks: {
                beginAtZero: true,
                stepSize: 10
              },
              gridLines: {
                display: false,
                drawBorder: false,
                drawOnChartArea: false
              }
            }
          ]
        }
      },
      arrAccessDataIndexHidden: [],
      arrAccessMallCodeHidden: ['Q', 'M', 'F', 'C'],
      startDay: '',
      endDay: '',
      yesterday: '',
      startNotBefore: '',
      startNotAfter: '',
      endNotBefore: '',
      endNotAfter: '',
      chartReady: false
    }
  },
  computed: {
    disableButtonApply () {
      return !this.chartReady || !this.startDay.trim() || !this.endDay.trim()
    }
  },
  methods: {
    formatAmount (value) {
      return (value === null || typeof value === 'undefined' || value === 0) ? '0' : `${Util.formatMoney(value)}`
    },
    handleClose () {
      $('.product-chart').css('height', '534px')
      $('#product-analytics-modal').modal('hide')
      this.chartReady = false
      this.startDay = ''
      this.endDay = ''

      this.startNotBefore = ''
      this.startNotAfter = ''
      this.endNotBefore = ''
      this.endNotAfter = ''

      this.arrAccessDataIndexHidden = []

      this.$emit('close')
    },
    handleSearch () {
      this.chartReady = false
      this.arrAccessDataIndexHidden = []
      this.getDataAnalytics('search')
    },
    async getDataAnalytics (getFrom = '') {
      $('.product-chart').css('height', '534px')
      this.chartReady = false
      let params = {
        asin: this.product.asin,
        from: this.startDay,
        to: this.endDay
      }
      await AnalyticsService.getSalesOrderQuantityAndAccessViewCount(params)
        .then((response) => {
          this.chartData.labels = response.labels
          this.chartData.datasets = response.data
          this.chartReady = true
          $('.product-chart').css('height', 'auto')
          let code = eventCode.manage_products.list_tab.click_show_analysis_button
          if (getFrom === 'search') {
            code = eventCode.manage_products.list_tab.click_analysis_apply_button
          }
          let properties = {
            asin: this.product.asin,
            from: this.startDay,
            to: this.endDay
          }
          this.analysicTrackLog(code, properties)
        })
    },

    analysicTrackLog (code, properties) {
      let logParams = {
        name: code,
        properties
      }
      EventService.postTrackLog(logParams)
    },
    setDefaultDateApply () {
      const startDate = new Date()
      const endDate = new Date()
      let start = startDate.setDate(startDate.getDate() - 31)
      let end = endDate.setDate(endDate.getDate() - 1)
      this.startDay = new Date(start).toLocaleDateString('ja-JP')
      this.endDay = new Date(end).toLocaleDateString('ja-JP')
      this.yesterday = end
    }
  },
  watch: {
    product (item) {
      if (Object.keys(item).length) {
        this.setDefaultDateApply()
        setTimeout(() => {
          $('#product-analytics-modal').modal('show')
          this.getDataAnalytics('show')
        }, 300)
      }
    },
    startDay (value) {
      if (value.trim()) {
        this.startNotAfter = this.endDay
        this.endNotBefore = this.startDay
      } else {
        this.endNotBefore = ''
      }
    },
    endDay (value) {
      if (value.trim()) {
        this.endNotAfter = this.yesterday
        this.startNotAfter = value
      } else {
        this.startNotAfter = this.yesterday
      }
    }
  }
}
</script>

<style scoped>
.product-analytics {
  padding: 20px;
}
.product-analytics .product {
  margin-bottom: 20px;
}
.product-analytics .product .image img {
  width: auto;
  max-width: 65px;
  max-height: 65px;
  object-fit: contain;
  margin-right: 10px;
}
.product-analytics .form-search {
  margin-bottom: 20px;
}
.product-analytics .form-search .start-day, .end-day {
  display: flex;
  align-items: center;
}
.product-chart {
  border: 1px solid #ddd;
  padding: 10px;
}
.box-btn-close {
  text-align: right;
  padding-right: 0;
}
.box-btn-close button {
  background-color: #ddd;
}
@media (min-width: 1200px) {
  #product-analytics-modal .modal-lg {
    width: 1200px !important;
  }
  .product-analytics .product {
    display: flex;
    align-items: center;
  }
  .product-analytics .product .info .name, .asin {
    font-size: 16px;
  }
  .product-analytics .product .info .name {
    font-weight: bold;
  }
  .product-analytics .form-search .start-day label {
    width: 80px;
  }
  .product-analytics .form-search .end-day label {
    width: 55px;
  }
}
@media (max-width: 1199px) {
  #product-analytics-modal {
    padding-right: 10px;
    padding-left: 10px;
  }
  #product-analytics-modal .modal-lg {
    width: 100% !important;
    overflow-x: auto;
  }
  #product-analytics-modal .modal-content {
    width: max-content;
    max-width: max-content;
  }
  .product-analytics .product {
    display: flex;
    align-items: center;
  }
  .product-analytics .product .info .name, .asin {
    font-size: 14px;
  }
  .product-analytics .product .info .name {
    font-weight: bold;
  }
  .product-analytics .form-search .start-day label {
    width: 80px;
  }
  .product-analytics .form-search .end-day label {
    width: 55px;
  }
  .product-chart {
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductAnalytics.vue